import { authHeader, accountHeader, BASE_URL, bestEffortRequest, handleResponse } from '@helpers/api';

export const brandsService = {
    get,
    addOrUpdateBrand,
    deleteBrand,
    getAll,
    uploadLogo,
    getDefault,
    startSetup,
    getSetupRun,
    completeSetupImports,
};

function get(page, pageSize) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/locations/brands?page=${page}&pageSize=${pageSize}`, requestOptions).then(
        handleResponse,
    );
}

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/locations/brands?returnAll=true`, requestOptions).then(handleResponse);
}

function getDefault() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/locations/brands/default`, requestOptions).then(handleResponse);
}

function addOrUpdateBrand(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/locations/brands`, requestOptions).then(handleResponse);
}

function deleteBrand(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/locations/brands/${id}`, requestOptions).then(handleResponse);
}

function startSetup(locations) {
    return bestEffortRequest(`${BASE_URL}api/locations/brands/setup`, {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(locations),
    });
}

function getSetupRun(runId) {
    return bestEffortRequest(`${BASE_URL}api/locations/brands/setup/${runId}`, {
        method: 'GET',
        headers: authHeader(),
    });
}

function completeSetupImports(runId) {
    return bestEffortRequest(`${BASE_URL}api/locations/brands/setup/${runId}/imports-completed`, {
        method: 'POST',
        headers: authHeader(),
    });
}

function uploadLogo(data) {
    const user = JSON.parse(localStorage.getItem('user'));
    const requestOptions = {
        method: 'POST',
        headers: {
            Authorization: 'Bearer ' + user.token,
            ...accountHeader(),
        },
        body: data,
    };

    return fetch(`${BASE_URL}api/locations/brands/upload-logo`, requestOptions).then(handleResponse);
}
